export default {
  'dashboard.dispatched_order_summary.number_of_orders': '出貨單總數',
  'dashboard.dispatched_order_summary.number_of_dispatched_orders': '已出貨單量',
  'dashboard.dispatched_order_summary.order_date': '日子',
  'dashboard.today_pending_orders': '待處理出貨單',
  'dashboard.today_packed_orders': '已包裝量',
  'dashboard.today_dispatched_orders': '已出貨量',
};
